export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CASTING_CENTRIFUGAL.6078d946.png";